import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.editModel ? _c('div', [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "mb-6 required",
    attrs: {
      "label": _vm.$i18n_t('AlarmLogs.reports.wizard.name'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "hide-details": ""
    },
    model: {
      value: _vm.editModel.meta.title,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.meta, "title", $$v);
      },
      expression: "editModel.meta.title"
    }
  }), _c(VAutocomplete, {
    staticClass: "mb-6 required",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": !!_vm.editModel.id,
      "disabled": !!_vm.editModel.id,
      "loading": _vm.accounts.length === 0,
      "rules": _vm.requiredRule,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n          " + _vm._s(data.item.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n        ")];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n              " + _vm._s(data.item.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n            ")])], 1)];
      }
    }], null, false, 10669288),
    model: {
      value: _vm.editModel.tenantId,
      callback: function ($$v) {
        _vm.$set(_vm.editModel, "tenantId", $$v);
      },
      expression: "editModel.tenantId"
    }
  }), _c(VSelect, {
    staticClass: "required",
    attrs: {
      "items": _vm.reportTypes,
      "readonly": !!_vm.editModel.id,
      "disabled": !!_vm.editModel.id,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$i18n_t('AlarmLogs.reports.wizard.reportTypes.label'),
      "hide-details": ""
    },
    model: {
      value: _vm.editModel.filters.originType,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.filters, "originType", $$v);
      },
      expression: "editModel.filters.originType"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_vm.markdownEdit ? _c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.editModel.meta.description || ''
    }
  })], 1)], 1) : _c(VCard, [_c(VTextarea, {
    attrs: {
      "data-cy": "input_report_description",
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rows": "7",
      "hide-details": "auto",
      "clearable": ""
    },
    model: {
      value: _vm.editModel.meta.description,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.meta, "description", $$v);
      },
      expression: "editModel.meta.description"
    }
  })], 1), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "label": _vm.$i18n_t('Common.mdeditor'),
      "color": _vm.color
    },
    model: {
      value: _vm.markdownEdit,
      callback: function ($$v) {
        _vm.markdownEdit = $$v;
      },
      expression: "markdownEdit"
    }
  })], 1)], 1), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.editModel.tenantId || !_vm.editModel.meta.title,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('nextStep');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n  ")])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };